/* eslint-disable react/prop-types */
import React from 'react'
import Image from 'components/image'
import classNames from 'classnames'
import { InfoButton } from 'components/buttons'
import { numberToCurrency } from 'lib/money'
import { track, useTracking } from 'lib/analytics'

export const Offer = ({ offer, openRedirectModal, regItem }) => {
  const { price, storeDisplayName, storeIconName, url } = offer
  const tracker = useTracking()
  const handleOfferClick = () => {
    openRedirectModal({
      url,
      storeDisplayName,
      regItem,
      isShopRegistryView: false,
      onRedirectSuccess: () => {},
    })
    tracker.trackEvent({
      event: track.registryProductOfferClicked,
      store: storeDisplayName,
    })
  }
  return (
    <div
      className="flex ptm align-center small"
      onClick={handleOfferClick}
      onKeyPress={handleOfferClick}
      role="button"
      style={{ cursor: 'pointer' }}
      tabIndex={0}
    >
      <span
        className={classNames(
          'icon-offer',
          `icon-offer-${storeIconName}`,
          'mrs'
        )}
      />
      <span className="flex grow" style={{ overflow: 'hidden' }}>
        {storeDisplayName}
      </span>
      {price ? <span className="small">{numberToCurrency(price)}</span> : null}
      <div className="plm">
        <InfoButton empty pill size="small" className="phl">
          Buy{' '}
          <Image
            alt="Open New Tab Icon"
            src="https://res.cloudinary.com/babylist/image/upload/v1631884523/redirect_arrow_quj8qr.svg"
            lazyLoad={false}
          />
        </InfoButton>
      </div>
    </div>
  )
}
